<script setup lang="ts">
const emits = defineEmits(['showTeslaPopup'])
</script>

<template>
    <div
        class="w-full tracking-light bg-primary-light-strong text-white flex items-center justify-between p-4"
    >
        <div class="flex items-center gap-4">
            <IconInfoCircle class="h-5" />
            <p class="text-fifteen-exploitation leading-6 font-normal">
                {{ $t('charge_with_chargemap_pass') }}
            </p>
        </div>
        <p
            class="text-eleven leading-loose font-semibold cursor-pointer px-3 border border-white rounded text-center"
            @click="emits('showTeslaPopup')"
        >
            {{ $t('learn_more') }}
        </p>
    </div>
</template>
